import { lazy } from "react";

const widgetRegistry = {
  // Banner Widgets
  BasicBanner: lazy(() => import('./banner/BasicBanner').then(m => ({ default: m.default }))),
  EssentialBanner: lazy(() => import('./banner/EssentialBanner').then(m => ({ default: m.default }))),
  ClassicBanner: lazy(() => import('./banner/ClassicBanner').then(m => ({ default: m.default }))),
  PrimeBanner: lazy(() => import('./banner/PrimeBanner').then(m => ({ default: m.default }))),
  
  // Navigation Widgets
  BasicNav: lazy(() => import('./nav').then(m => ({ default: m.BasicNav }))),
  EssentialNav: lazy(() => import('./nav').then(m => ({ default: m.EssentialNav }))),
  ClassicNav: lazy(() => import('./nav').then(m => ({ default: m.ClassicNav }))),
  PrimeNav: lazy(() => import('./nav').then(m => ({ default: m.PrimeNav }))),
  
  // Experience Widgets
  BasicExperienceCard: lazy(() => import('./experience').then(m => ({ default: m.BasicExperienceCard }))),
  ClassicExperienceCard: lazy(() => import('./experience').then(m => ({ default: m.ClassicExperienceCard }))),
  EssentialExperience: lazy(() => import('./experience').then(m => ({ default: m.BasicExperienceCard }))),
  PrimeExperience: lazy(() => import('./experience').then(m => ({ default: m.PrimeExperience }))),
  
  // Popular Items Widgets
  BasicPopularItems: lazy(() => import('./popular').then(m => ({ default: m.BasicPopularItems }))),
  ClassicPopularItems: lazy(() => import('./popular').then(m => ({ default: m.ClassicPopularItems }))),
  EssentialPopularItems: lazy(() => import('./popular').then(m => ({ default: m.EssentialPopularItems }))),
  PrimePopularItems: lazy(() => import('./popular').then(m => ({ default: m.PrimePopularItems }))),
  
  // Combo Widgets
  BasicCombo: lazy(() => import('./combo').then(m => ({ default: m.BasicCombo }))),
  ClassicCombo: lazy(() => import('./combo').then(m => ({ default: m.ClassicCombo }))),
  EssentialCombo: lazy(() => import('./combo').then(m => ({ default: m.EssentialCombo }))),
  PrimeCombo: lazy(() => import('./combo').then(m => ({ default: m.PrimeCombo }))),
  
  // Footer Widgets
  BasicFooter: lazy(() => import('./footer').then(m => ({ default: m.BasicFooter }))),
  EssentialFooter: lazy(() => import('./footer').then(m => ({ default: m.EssentialFooter }))),
  ClassicFooter: lazy(() => import('./footer').then(m => ({ default: m.ClassicFooter }))),
  PrimeFooter: lazy(() => import('./footer').then(m => ({ default: m.PrimeFooter }))),
  
  // Contact Form Widgets
  BasicContactForm: lazy(() => import('./contact').then(m => ({ default: m.BasicContactForm }))),
  ClassicContactForm: lazy(() => import('./contact').then(m => ({ default: m.ClassicContactForm }))),
  PrimeContactForm: lazy(() => import('./contact').then(m => ({ default: m.PrimeContactForm }))),
  ModernContactForm: lazy(() => import('./contact').then(m => ({ default: m.ModernContactForm }))),
  
  // Story Widgets
  BasicStory: lazy(() => import('./story').then(m => ({ default: m.BasicStory }))),
  ClassicStory: lazy(() => import('./story').then(m => ({ default: m.ClassicStory }))),
  PrimeStory: lazy(() => import('./story').then(m => ({ default: m.PrimeStory }))),
  ModernStory: lazy(() => import('./story').then(m => ({ default: m.ModernStory }))),
  
  // Blog Widgets
  BasicBlog: lazy(() => import('./blog').then(m => ({ default: m.BasicBlog }))),
  ClassicBlog: lazy(() => import('./blog').then(m => ({ default: m.ClassicBlog }))),
  PrimeBlog: lazy(() => import('./blog').then(m => ({ default: m.PrimeBlog }))),
  ModernBlog: lazy(() => import('./blog').then(m => ({ default: m.ModernBlog }))),
  
  // Event Widgets
  BasicEvents: lazy(() => import('./event').then(m => ({ default: m.BasicEvents }))),
  ClassicEvents: lazy(() => import('./event').then(m => ({ default: m.ClassicEvents }))),
  PrimeEvents: lazy(() => import('./event').then(m => ({ default: m.PrimeEvents }))),
  ModernEvents: lazy(() => import('./event').then(m => ({ default: m.ModernEvents }))),
  
  // Gallery Widgets
  BasicGallery: lazy(() => import('./gallery').then(m => ({ default: m.BasicGallery }))),
  ClassicGallery: lazy(() => import('./gallery').then(m => ({ default: m.ClassicGallery }))),
  PrimeGallery: lazy(() => import('./gallery').then(m => ({ default: m.PrimeGallery }))),
  ModernGallery: lazy(() => import('./gallery').then(m => ({ default: m.ModernGallery }))),
  
  // Layout Widgets
  LeftContentRightMediaLayout: lazy(() => import('./layout/LeftContentRightMedia').then(m => ({ default: m.default }))),
  RightContentLeftMediaLayout: lazy(() => import('./layout/RightContentLeftMedia').then(m => ({ default: m.default }))),
  SplitPromoCard: lazy(() => import('./layout/SplitPromo').then(m => ({ default: m.default }))),
  
  // Social Media Widgets
  BasicSocialFollow: lazy(() => import('./social/BasicSocialFollow').then(m => ({ default: m.default }))),
} as const;

export type WidgetType = keyof typeof widgetRegistry;
export default widgetRegistry;
